module.exports = __webpack_public_path__ + "img/scenario_12.24973982.jpg";